import React, { useEffect, useState } from "react"

import BlogDetail from "./blog-detail/detail"
import BreadcrumbComponent from "../breadcrumb/breadcrum"
import { FETCH_POST_DETAIL } from "./blog-actions/blog-actions"
import Spinner from "../spinner/spinner"
import Layout from "../layout/layout"

const BlogDetailPage = ({ location }) => {
  const [title, setTitle] = useState("Blog") // eslint-disable-line no-unused-vars
  const [loading, setLoading] = useState(false) // eslint-disable-line no-unused-vars
  // eslint-disable-next-line no-unused-vars
  const [articles, setArticles] = useState([])
  const pages = [{ link: "/", name: "Home" }]
  const page = { link: "/blog", name: "Blog" }

  const pathname = location.pathname
  let slug = pathname.split("/")
  slug = slug[2]

  useEffect(() => {
    setLoading(true)
    FETCH_POST_DETAIL(slug, setLoading, setArticles)
  }, [slug])
  return (
    <Layout noVerification={true}>
      {!loading && articles.length > 0 ? (
        <div className="front-page">
          <BreadcrumbComponent
            styles="mb-0"
            currentPage={{ link: "/", name: articles?.[0]?.title?.rendered }}
            pages={[...pages, page]}
          />
          <BlogDetail articles={articles} />
        </div>
      ) : (
        <Spinner />
      )}
    </Layout>
  )
}

export default BlogDetailPage
